import { TextFieldProps } from '@mui/material';
import { FC } from 'react';
import { useLayoutsQuery } from '../../generated/graphql';
import useConcession from '../../hooks/useConcession';
import config from '../../services/config';
import SelectAutocompleteDataField from '../SelectAutocompleteDataField/SelectAutocompleteDataField';

interface LayoutFieldProps {
    textFieldProps?: TextFieldProps
    disabled?: boolean
}

const LayoutField: FC<LayoutFieldProps> = props => {
    const { textFieldProps = { variant: "standard" }, disabled } = props
    const concession = useConcession()
    return (
        <SelectAutocompleteDataField
            name="layout"
            label="Esquema"
            query={useLayoutsQuery}
            textFieldProps={textFieldProps}
            disabled={disabled}
            queryPaging={config.DEFAULT_FIELD_QUERY_PAGING}
            queryFilter={{
                concession: {
                    id: {
                        eq: concession?.id
                    }
                }
            }}
        />
    )
}

export default LayoutField
